'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduce = require('ramda/src/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _most = require('most');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var concatArray = (0, _reduce2.default)(function (main$, child$) {
  return main$ == null ? child$ : (0, _most.concat)(main$, child$);
}, null);

exports.default = concatArray;